import { render, staticRenderFns } from "./areaToper.vue?vue&type=template&id=edc8d9ce&scoped=true&"
import script from "./areaToper.vue?vue&type=script&lang=js&"
export * from "./areaToper.vue?vue&type=script&lang=js&"
import style0 from "./areaToper.vue?vue&type=style&index=0&id=edc8d9ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc8d9ce",
  null
  
)

export default component.exports